import { useId } from "react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import type { IFormFieldProps, IInputProps } from "@/ui-kit";
import { FormField, Input } from "@/ui-kit";
import { get } from "../utils";

type IProps = Omit<IInputProps, "label"> &
  Partial<IFormFieldProps> & {
    name: string;
    formElementClass?: string;
    clear?: boolean;
  };

export const InputControl = (props: IProps) => {
  const {
    label,
    message,
    required,
    tooltipContent,
    accessory,
    formElementClass,
    name,
    invalid,
    clear,
    description,
    ...restInputProps
  } = props;
  const { control } = useFormContext();
  const { errors } = useFormState();
  const errorMessage = get(errors, name)?.message as string | undefined;
  const inputId = useId();

  const inputElement = (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onFieldChange, onBlur, value } }) => {
        const handleClear = () => {
          onFieldChange("");
        };

        return (
          <Input
            {...restInputProps}
            required={required}
            name={name}
            onChange={onFieldChange}
            onBlur={onBlur}
            value={value}
            invalid={invalid || !!errorMessage}
            autoComplete={restInputProps.autoComplete ?? "off"}
            id={inputId}
            onClear={
              restInputProps.onClear || (clear ? handleClear : undefined)
            }
          />
        );
      }}
    />
  );

  return (
    <FormField
      label={label}
      message={message ?? errorMessage}
      description={description}
      required={required}
      tooltipContent={tooltipContent}
      className={formElementClass}
      accessory={accessory}
      htmlFor={inputId}
    >
      {inputElement}
    </FormField>
  );
};
